import type { Action, Field, Form } from '@jmvdevelop/svelte-form';
import { addFieldOrRootError } from '$lib/validator/validatorUtils';

export function validateEmail<TValues, TValue>(
    value: string | undefined | null,
    {
        form,
        field,
        message,
        notBlank = false,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>;
        notBlank?: boolean;
        message: string;
    },
): Action<TValues, string> {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (value === '' || value == null) {
        if (notBlank) {
            return addFieldOrRootError(form, field, message);
        } else {
            return (s) => s;
        }
    }

    if (!emailRegex.test(value)) {
        return addFieldOrRootError(form, field, message);
    }

    return (s) => s;
}
